import React, { useEffect, useState } from 'react'
import loader from '../../../../assets/img/loader.svg'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/PartnerInfo.css'
import {
    Paper,
    Box,
    Typography,
    Avatar,
    Grid,
    Divider,
    Chip,
    CircularProgress,
    Button,
    IconButton,
} from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import BusinessIcon from '@mui/icons-material/Business'
import EditIcon from '@mui/icons-material/Edit'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import editImage from "@/assets/img/settings/icons/edit.svg"
import Api from '@/_helpers/Api'
import Skeleton from 'react-loading-skeleton'

function Info(props) {
    const [loadingLogo, setLoadingLogo] = useState(false)

    const auth = useAuthDataContext()


    // Format date to "15 Авг 2025 / 09:30" format
    const formatDate = (dateString) => {
        if (!dateString) return '-'

        const date = new Date(dateString)
        const months = ['Яну', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек']

        const day = date.getDate()
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')

        return `${day} ${month} ${year} / ${hours}:${minutes}`
    }

    // Calculate time remaining between now and expiry date
    const calculateTimeRemaining = (expiryDate) => {
        if (!expiryDate) return '-'

        const now = new Date()
        const expiry = new Date(expiryDate)
        const diff = expiry - now

        if (diff <= 0) return trans('random.expired')

        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

        const months = Math.floor(days / 30)
        const remainingDays = days % 30

        if (months > 0) {
            return `${months}м ${remainingDays}д ${hours}ч`
        } else {
            return `${days}д ${hours}ч`
        }
    }

    // Handle logo upload
    const handleLogoUpload = async (e) => {
        e.preventDefault()

        setLoadingLogo(true)

        const formData = new FormData(e.target)

        Api.post('partners/edit-logo', formData)
            .then(res => {
                props.attachNewLogo(res.data.logo)
            })
            .finally(() => {
                setLoadingLogo(false)
            })
    }

    return (
        props.loading
            ?
            <div className='pannel'>
                <Skeleton height={80} count={5} />
            </div>
            :
            <div className='row'>

                <div className='col user-info'>
                    <div className='pannel'>
                        {loadingLogo ?
                            <Skeleton
                                height={100}
                                width={400}
                                count={1}
                                style={{
                                    marginBottom: "25px"
                                }}
                            />
                            :
                            <div className='logo'>
                                <img src={props.partner.logo} alt='' />

                                <form className='right' id="logo-form" onSubmit={handleLogoUpload}>
                                    {!auth.isAdmin() ?
                                        <>
                                            <input
                                                type="file"
                                                id="logo-upload"
                                                name="image"
                                                accept="image/jpeg,image/jpg,image/png,image/gif"
                                                style={{ display: 'none' }}
                                                onChange={() => {
                                                    document.getElementById('logo-form').requestSubmit()
                                                }}
                                            />
                                            <button
                                                type="button"
                                                className="button-add button-small"
                                                onClick={() => document.getElementById('logo-upload').click()}
                                            >
                                                {trans('buttons.attachNewLogo')}
                                            </button>
                                            <p
                                                style={{
                                                    marginBottom: "5px"
                                                }}
                                            >
                                                {trans('labels.recommendedSize')}
                                            </p>
                                            <p>
                                                {trans('labels.allowedFormats')}
                                            </p>
                                        </>
                                        :
                                        <>
                                        </>
                                    }
                                </form>
                            </div>
                        }

                        <div className='pannel main-info'>
                            <div className='head'>
                                <h3>
                                    {props.partner?.name}
                                </h3>

                                {auth.isManager() ?
                                    <button className="button-small" onClick={props.handleEdit}>
                                        <img src={editImage} alt="edit" />
                                        {trans('buttons.edit')}
                                    </button>
                                    :
                                    <>
                                    </>
                                }
                            </div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            {trans('labels.email')}:
                                        </td>
                                        <td>
                                            {props.partner.email || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {trans('labels.phone') || 'Тел. за контакти'}:
                                        </td>
                                        <td>
                                            {props.partner.phone || '-'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {trans('labels.address') || 'Адрес'}:
                                        </td>
                                        <td>
                                            {props.partner.address || '-'}
                                            {props.partner.lat && props.partner.lon && (
                                                <b>
                                                    (г.ш. {props.partner.lat}, г.д. {props.partner.lon})
                                                </b>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {trans('labels.workDays') || 'Работни дни'}:
                                        </td>
                                        <td>
                                            {props.partner.work_days_text.map((day, idx) => (
                                                <Chip
                                                    key={idx}
                                                    label={day}
                                                    size="small"
                                                    variant="outlined"
                                                    style={{ marginRight: 8 }}
                                                />
                                            ))}
                                        </td>
                                    </tr>
                                    {auth.isAdmin() ? (
                                        <>
                                            <tr>
                                                <td>
                                                    {trans('labels.active')}:
                                                </td>
                                                <td>
                                                    {props.partner.active ? trans('labels.yes') : trans('labels.no')}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {trans('labels.superpartner')}:
                                                </td>
                                                <td>
                                                    {props.partner.superpartner ? trans('labels.yes') : trans('labels.no')}
                                                </td>
                                            </tr>
                                        </>)
                                        :
                                        <>
                                        </>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Right Side - Subscription Details */}
                <div
                    className='col subscription-info'
                    style={{
                        maxWidth: "325px",
                        flexShrink: 0,
                    }}
                >
                    <div className='pannel'>
                        <h3>
                            {trans('labels.subscriptionDetails')}
                        </h3>


                        <p>
                            {trans('labels.activeSubscription')}
                        </p>
                        <h5>
                            {props.partner.license?.name}
                        </h5>
                        <hr />
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        {trans('labels.activatedOn')}
                                    </td>
                                    <td>
                                        {formatDate(props.partner.license_activated_at)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {trans('labels.validUntil')}
                                    </td>
                                    <td>
                                        {formatDate(props.partner.license_expires_at)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className='bottom'>
                            <p>
                                {trans('labels.expiresIn')}
                            </p>
                            <h4>
                                {calculateTimeRemaining(props.partner.license_expires_at)}
                            </h4>
                        </div>
                        {!auth.isAdmin() ?
                            <div className='buttons'>
                                <button
                                    className='button-default'
                                    onClick={() =>
                                        window.open(`https://website.eus.tech/renew-license?token=${auth.token()}`, "_blank")
                                    }
                                    style={{
                                        marginRight: 0,
                                    }}
                                >
                                    {trans('buttons.renewPlan')}
                                </button>
                                {!props.partner.license.is_highest_plan ?
                                    <button
                                        className='button-primary'
                                        onClick={() =>
                                            window.open(`https://website.eus.tech/subscribe?token=${auth.token()}`, "_blank")
                                        }
                                        style={{
                                            marginRight: 0,
                                        }}
                                    >
                                        {trans('buttons.upgradePlan')}
                                    </button>
                                    :
                                    <>
                                    </>
                                }
                            </div>
                            :
                            <>
                            </>
                        }
                    </div>
                </div>
            </div>
    )
}

export default Info